export default __webpack_public_path__ + "static/media/qr-templated-lubes.b4ac4a56.png";